import Swiper from 'swiper/bundle';

export function slider() {
	const sliders = []

	// Fallback Optionen mit 3 Items
	const defaultOptions = {
		slidesPerView: 3,
		spaceBetween: 24
	}

	// Thumbnails erst ab Tablet (768px); darunter nur Hauptslider
	const THUMBS_MIN_WIDTH = 768

	// Default Thumbnail Optionen (nur sichtbar >= THUMBS_MIN_WIDTH)
	const defaultThumbsOptions = {
		slidesPerView: 2,
		spaceBetween: 24,
		watchSlidesProgress: true,
		breakpoints: {
			1024: { slidesPerView: 3 }
		}
	}

	// Swiper-Module: Standard-Selektoren innerhalb von .swiper__container (Twig muss nichts wiederholen)
	const DEFAULT_PAGINATION_EL = '.swiper-pagination'
	const DEFAULT_NAV_NEXT = '.swiper-button-next'
	const DEFAULT_NAV_PREV = '.swiper-button-prev'
	const FRACTION_PAGINATION_MIN = 7

	const resolveSelector = (container, selector) => {
		if (!selector || typeof selector !== 'string' || !container) {
			return selector
		}

		const scoped = container.querySelector(selector)
		return scoped || selector
	}

	/**
	 * Pagination: Standard .swiper-pagination, wenn im Container vorhanden (oder explizites el aus JSON).
	 * Ohne passendes Element im Container wird kein Modul gesetzt (Ausnahme: el per JSON → Fallback-String für Swiper).
	 */
	const applyPaginationTargets = (container, options) => {
		if (options.pagination === false) return

		const pagCfg =
			typeof options.pagination === 'object' && options.pagination !== null
				? { ...options.pagination }
				: {}

		const elSource =
			pagCfg.el !== undefined ? pagCfg.el : DEFAULT_PAGINATION_EL

		let resolvedEl = null
		if (typeof elSource === 'string') {
			const hit = container.querySelector(elSource)
			if (hit) resolvedEl = hit
			else if (pagCfg.el !== undefined) resolvedEl = elSource
		} else {
			resolvedEl = elSource
		}

		if (resolvedEl) {
			const pagination = { ...pagCfg, el: resolvedEl }

			if (pagCfg.clickable === undefined) {
				pagination.clickable = true
			}

			if (!pagCfg.type) {
				const slideCount = container.querySelectorAll(
					'.swiper[data-swiper-options] > .swiper-wrapper > .swiper-slide'
				).length

				if (slideCount >= FRACTION_PAGINATION_MIN) {
					pagination.type = 'fraction'
					pagination.renderFraction = (currentClass, totalClass) =>
						`<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
				}
			}

			options.pagination = pagination
		} else {
			delete options.pagination
		}
	}

	/**
	 * Navigation: Standard-Pfeile, wenn im Container vorhanden (oder nextEl/prevEl aus JSON).
	 */
	const applyNavigationTargets = (container, options) => {
		if (options.navigation === false) return

		const navCfg =
			typeof options.navigation === 'object' && options.navigation !== null
				? { ...options.navigation }
				: {}

		const resolveNavPart = (cfgKey, defaultSel) => {
			const src = navCfg[cfgKey] !== undefined ? navCfg[cfgKey] : defaultSel
			if (typeof src === 'string') {
				const hit = container.querySelector(src)
				if (hit) return hit
				if (navCfg[cfgKey] !== undefined) return src
				return null
			}
			return src
		}

		const nextEl = resolveNavPart('nextEl', DEFAULT_NAV_NEXT)
		const prevEl = resolveNavPart('prevEl', DEFAULT_NAV_PREV)

		if (nextEl || prevEl) {
			options.navigation = {
				...navCfg,
				...(nextEl ? { nextEl } : {}),
				...(prevEl ? { prevEl } : {})
			}
		} else {
			delete options.navigation
		}
	}

	document.querySelectorAll('.swiper__container').forEach((container) => {
		const el = container.querySelector('.swiper[data-swiper-options]')
		if (!el) {
			return
		}

		let options = Object.assign({}, defaultOptions)
		const json = el.getAttribute('data-swiper-options')

		if (json) {
			try {
				const customOptions = JSON.parse(json)
				options = { ...defaultOptions, ...customOptions }
			} catch (e) {
				console.error('Invalid Swiper options:', json, e)
			}
		}

		applyPaginationTargets(container, options)
		applyNavigationTargets(container, options)

		if (options.scrollbar && options.scrollbar.el) {
			const scopedScrollbar = resolveSelector(container, options.scrollbar.el)
			if (scopedScrollbar) {
				options.scrollbar = { ...options.scrollbar, el: scopedScrollbar }
			}
		}

		// Check for thumbnails
		const thumbsEl = container.querySelector('.swiper-thumbs')
		let thumbsSwiper = null

		const thumbsMq = window.matchMedia(`(min-width: ${THUMBS_MIN_WIDTH}px)`)

		const connectThumbs = (mainSwiper) => {
			if (!thumbsSwiper || mainSwiper.params.thumbs?.swiper) {
				return
			}

			mainSwiper.params.thumbs = { swiper: thumbsSwiper }
			mainSwiper.thumbs.init()
			mainSwiper.thumbs.update(true)
			mainSwiper.update()
		}

		const initThumbsSwiper = (thumbsOptions) => {
			if (thumbsSwiper) {
				thumbsSwiper.update()
				return thumbsSwiper
			}

			thumbsSwiper = new Swiper(thumbsEl, thumbsOptions)
			sliders.push(thumbsSwiper)
			return thumbsSwiper
		}

		let thumbsOptions = null

		const thumbsSlideCount = thumbsEl
			? thumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length
			: 0

		if (thumbsEl && thumbsSlideCount > 1) {
			thumbsOptions = Object.assign({}, defaultThumbsOptions)
			const thumbsJson = thumbsEl.getAttribute('data-swiper-thumbs-options')

			if (thumbsJson) {
				try {
					const customThumbsOptions = JSON.parse(thumbsJson)
					// Merge breakpoints separately to avoid overwriting
					if (customThumbsOptions.breakpoints && defaultThumbsOptions.breakpoints) {
						customThumbsOptions.breakpoints = { ...defaultThumbsOptions.breakpoints, ...customThumbsOptions.breakpoints }
					}
					thumbsOptions = { ...defaultThumbsOptions, ...customThumbsOptions }
				} catch (e) {
					console.error('Invalid Swiper thumbs options:', thumbsJson, e)
				}
			}

			// Nicht auf display:none initialisieren – zerstört Slide-Maße
			if (thumbsMq.matches) {
				initThumbsSwiper(thumbsOptions)
				options.thumbs = { swiper: thumbsSwiper }
			}
		}

		const instance = new Swiper(el, options)
		sliders.push(instance)

		if (thumbsEl && thumbsOptions) {
			thumbsMq.addEventListener('change', (event) => {
				if (!event.matches) {
					return
				}

				initThumbsSwiper(thumbsOptions)
				connectThumbs(instance)
			})
		}
	})

	// Make sliders globally accessible for other modules
	window.sliders = sliders
	return sliders
}
